import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LoginPage from "../Screens/LoginPage";
import HomePage from "../Screens/HomePage";


const RouterApp: React.FC = () => {
  return (
 
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<HomePage />} />
      </Routes>
    
  );
};

export default RouterApp;